import { Link } from 'react-router';
import { DataTable } from '../components/DataTable.tsx';
import { ErrorState, LoadingState } from '../components/FdPrimitives.tsx';
import { useFetch } from '../hooks/useFetch.ts';

type Device = {
  alias: string;
  device_id: string;
  site_key: string;
  first_seen: string;
  last_seen: string;
  event_count: number;
  ip_count: number;
};

export function DevicesPage() {
  const state = useFetch<{ devices: Device[] }>('/devices');

  if (state.status === 'loading') return <LoadingState label="Loading devices" />;
  if (state.status === 'error') return <ErrorState message={state.message} />;

  return (
    <div className="page-stack">
      <DataTable
        title="Devices"
        icon="devices"
        rows={state.data.devices}
        emptyTitle="No devices found"
        emptyMessage="Device fingerprints will appear here after collect events arrive."
        columns={[
          {
            key: 'alias',
            header: 'Alias',
            className: 'cid',
            render: (d) => <Link to={`/devices/${encodeURIComponent(d.alias)}`}>{d.alias}</Link>,
          },
          { key: 'site_key', header: 'Site key' },
          { key: 'event_count', header: 'Events' },
          { key: 'ip_count', header: 'IPs' },
          { key: 'first_seen', header: 'First seen' },
          { key: 'last_seen', header: 'Last seen' },
        ]}
      />
    </div>
  );
}
